import styles from "./InviteTask.module.scss";
import { ReferralLinkInvite } from "../../../../components/ReferralLinkInvite/ReferralLinkInvite";
import { PageTitleBlock } from "../../../../components/PageTitleBlock/PageTitleBlock";
import { ReferalsList } from "./ReferalsList";
import { CurrencySmallIcon } from "../../../../components/CurrencySmallIcon/CurrencySmallIcon";
import fragmentIcon from "../../../../icons/fragment.png";
import { Ticket, TicketType } from "../../../../components/TicketsPanel/Ticket";

export const InviteTaskPage = () => {
    const getFragmentIcon = () => <img className={ styles.fragmentImage} src={ fragmentIcon } alt='fragment' />;

    const getRewards = () => {
        return (
            <>
                <div>10% c сертификата друга в виде { getFragmentIcon() }</div>
                <div className={styles.secondRewardLine}>
                    <span className={styles.currencyItem }><CurrencySmallIcon value={ 500000 } /></span>
                    <span className={ styles.fragmentsBlock }>{ getFragmentIcon() } 2</span>
                    <span>
                        <span className={styles.ticketsBlock}>
                            <Ticket type={TicketType.Epic} value={19} precission={0} context='modal' />
                        </span>
                    </span>
                </div>
            </>
        );
    }

    const getDescription = () => getRewards();
    
    return (
        <div className={styles.tasksWrapper}>
            <PageTitleBlock
                pageTitle={"Приглашать друзей выгодно"}
                pageDescription={ getDescription() }
            />
            
            <ReferralLinkInvite />
            <ReferalsList />
        </div>
    );
};
